var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.5H16V8.5H21C21.2652 8.5 21.5196 8.60536 21.7071 8.79289C21.8946 8.98043 22 9.23478 22 9.5V17L16 13.5L16.036 21.562L18.259 19.412L20.041 22.5H9C8.73478 22.5 8.48043 22.3946 8.29289 22.2071C8.10536 22.0196 8 21.7652 8 21.5V16.5H6V14.5H8V9.5C8 9.23478 8.10536 8.98043 8.29289 8.79289C8.48043 8.60536 8.73478 8.5 9 8.5H14V6.5ZM22 17.838V21.5C22.0001 21.6042 21.9839 21.7078 21.952 21.807L19.992 18.413L22 17.838ZM4 14.5V16.5H2V14.5H4ZM4 10.5V12.5H2V10.5H4ZM4 6.5V8.5H2V6.5H4ZM4 2.5V4.5H2V2.5H4ZM8 2.5V4.5H6V2.5H8ZM12 2.5V4.5H10V2.5H12ZM16 2.5V4.5H14V2.5H16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.9780d354627c2f8476f2aa1f754c767f.svg";
export { ForwardRef as ReactComponent };